import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { CheckIcon, Trash2Icon, TriangleAlertIcon } from 'lucide-react';
import { toast } from 'sonner';

import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';

import Loading from '../../../feedback/loading.jsx';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import { Checkbox } from '../../../ui/checkbox.jsx';
import PortalHeading from '../heading.jsx';

export const DialogDeleteAccount = () => {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const mutationDeleteAccount = useMutation({
    mutationFn: async () => {
      await msCatalystApi.delete('/auth/users');

      return true;
    },
    onSuccess: () => {
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    },
    onError: () => {
      toast.error('Ocorreu um erro ao eliminar a sua conta', {
        description: 'Por favor tente novamente mais tarde',
      });
    },
  });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant="portal-destructive"
          className="mx-auto flex w-full flex-row items-center rounded-full text-base lg:w-1/2 xl:w-1/3"
        >
          <Trash2Icon /> Eliminar a minha conta
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        {mutationDeleteAccount.isPending ? (
          <div className="flex w-full justify-center">
            <Loading message="A eliminar sua conta..." />
          </div>
        ) : mutationDeleteAccount.isSuccess ? (
          <div className="flex flex-col items-center">
            <CheckIcon className="size-40 text-success" />
            <PortalHeading className="text-center !text-2xl">
              Conta eliminada com sucesso.
            </PortalHeading>

            <div className="py-4 text-center">
              <p>Por favor aguarde enquanto o redirecionamos.</p>
            </div>
          </div>
        ) : (
          <>
            <AlertDialogHeader>
              <TriangleAlertIcon className="mx-auto size-32 text-portal-destructive" />
              <AlertDialogTitle className="text-xl text-red-500">
                Tem a certeza?
              </AlertDialogTitle>
              <AlertDialogDescription>
                <span>
                  <span>
                    A sua conta será eliminada permanentemente do sistema. Caso
                    possua cupões, estes serão eliminados.
                  </span>
                </span>
              </AlertDialogDescription>
              <AlertDialogDescription className="font-bold text-red-500">
                ESTA AÇÃO É IRREVERSÍVEL.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <div className="flex flex-row items-start space-x-2">
              <Checkbox
                className="mt-0.5"
                checked={checked}
                onCheckedChange={setChecked}
              />
              <AlertDialogDescription className="space-y-0 text-sm">
                Eu concordo que esta ação tem consequências irreversíveis e que
                mesmo assim quero realizá-la.
              </AlertDialogDescription>
            </div>
            <AlertDialogFooter>
              <Button
                disabled={!checked}
                onClick={async (event) => {
                  event.preventDefault();

                  mutationDeleteAccount.mutate();
                }}
              >
                Eliminar
              </Button>

              <AlertDialogCancel>Cancelar</AlertDialogCancel>
            </AlertDialogFooter>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
};
